import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { NgbDateStruct, NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MeetingagendacomplianceComponent } from '../meetingagendacompliance/meetingagendacompliance.component';
import { MeetingMasterService } from '../../../services/meetingMaster.service';
import { environment } from '../../../../environments/environment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import * as _ from 'lodash';
declare var $: any;
declare var jQuery: any;

import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs/Rx';

@Component({
  selector: 'app-meetingagenda',
  templateUrl: './meetingagenda.component.html',
  styleUrls: ['./meetingagenda.component.css']
})
export class MeetingagendaComponent implements OnInit {

  @Input('agendaObject') agendaObject: any;
  @Input('meetingObject') meetingObject: any;
  @Input('clickedAgenda') clickedAgenda: any;
  @Input('loadAgendaFromPagignation') loadAgendaFromPagignation: any;
  @Output() emitFileURL = new EventEmitter();

  agendaCompliances: any;
  isAgendaObjectEmpty: boolean;
  @ViewChild(DataTableDirective)
  dtElementAgendaCompliancePopUp: DataTableDirective;
  dtOptionsOfAgendaCompliancePopUp: DataTables.Settings = {};
  dtTriggerAgendaCompliancePopUp: Subject<any> = new Subject();

  agendaPdfIsAvailable: any;
  agendaUplaodedPdfID: any;
  agendaGenerationTitle: any;
  agendaGenerationNumber: any;
  agendaGenerationID: any;
  AgendaFile: any;
  count: number = null;
  AttachMent: any;
  showAgenda: any;
  hideAgenda: any;
  AgdNum: any;
  Number: any;
  FinalUrl: any;
  groupList: any = [];
  urlSafe: SafeResourceUrl;
  page: any = 0;
  
  // Agenda Voting Properties
  agendaVotes: any = {}; // Store votes by agendaID
  votingLoading: any = {}; // Track loading state per agenda
  votingError: any = {}; // Track errors per agenda

  viewMode: 'grid' | 'list' = 'list';

  setViewMode(mode: 'grid' | 'list') {
    this.viewMode = mode;
  }
  constructor(
    private modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private meetingMasterService: MeetingMasterService,
    private sanitizer: DomSanitizer) {

    this.meetingMasterService.Pagination.subscribe(id => {
      this.Number = id;
    })
  }

  ngOnChanges(){
    if(this.loadAgendaFromPagignation && this.loadAgendaFromPagignation.agendaId){
      console.log("000000", this.loadAgendaFromPagignation)
      this.clickFunc(this.loadAgendaFromPagignation.agendaId, this.loadAgendaFromPagignation.page)
    }
  }

  ngOnInit() {

    console.log('agendaObject:', this.agendaObject);
    let user = JSON.parse(localStorage.getItem("user"));

    if (!Array.isArray(this.agendaObject)) {
      this.agendaObject = [];
    }

    this.agendaObject = this.agendaObject.filter((element) => {
      const accessRights = element?.AgendaAccessRights;
      if (!Array.isArray(accessRights)) {
        return true;
      }
      return !accessRights.some(
        (subElement) =>
          subElement.UserGovevaId == user._id && subElement.View == false
      );
    });

    this.count = this.agendaObject.length;
    localStorage.setItem("AgendaCount", this.agendaObject.length);
    if (_.size(this.agendaObject)) {

      this.agendaObject = _.sortBy(this.agendaObject, o => o.Agendaorder)
      this.agendaObject = (this.agendaObject).map(function (item) {
        var o = Object.assign({}, item);

        o.fileType = Array.isArray(item.AgendaGenerationPdf)
          ? item.AgendaGenerationPdf.map(function (subItem) {
              var oSub = Object.assign({}, subItem);
              oSub = (subItem.UploadFileName).slice(-3)

              return oSub;
            })
          : [];

        return o;

      });

      this.isAgendaObjectEmpty = false;
    }
    else {
      this.isAgendaObjectEmpty = true
    }

    this.dtOptionsOfAgendaCompliancePopUp = {
      destroy: true,
      scrollY: "400px",
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 5,
      search: true,
      order: [1, 'asc'],
      columnDefs: [{ orderable: false, targets: [0, 1, 2, 3] }],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
    }
    
    // Load voting data for all agendas
    if (this.meetingObject && this.meetingObject._id) {
      this.loadAllAgendaVotes();
    }
  }

  agendasCompliancepopUpDataToShow(agenda) {
    const modalRef = this.modalService.open(MeetingagendacomplianceComponent, { size: 'lg' });
    modalRef.componentInstance.agendaComplianceObject = agenda.AgendaCompliance;
  }

  initiateUploadAgendaPdf(data) {

    this.agendaPdfIsAvailable = data.AgendaGenerationPdf.IsPdfAvailable;
    this.agendaUplaodedPdfID = data.AgendaGenerationPdf.DocumentManagementID;
    this.agendaGenerationTitle = data.AgendaTitle;
    this.agendaGenerationNumber = data.AgendaNumber;
    this.agendaGenerationID = data._id;

    this.AgendaFile = data.AgendaGenerationPdf.map(element => {

      var o = Object.assign({}, element)
      o.FileType = (element.PdfName).substr(-3)

      return o;
    })

    $("#AgendaPdfUploadTitle").html("Attachment For Agenda");
    $("#agendaPdfUploadDialog").modal('toggle');
  }


  downloadDocumentFile(fileID, fileType) {
    console.log("fileTypefileType", fileType)
    if (fileType == 'PDF' || fileType == 'pdf') {
      $('#myModalForDocument').data('modal', null);
      console.log('meetingagendacomponent')
      this.meetingMasterService.getAttendanceFileName(fileID).then(response => {
        var url = environment.PSSFileurl + "/Document_Type/" + response.data.Filename + "#toolbar=0";
        var arr = url.split('https:'); // split string        
        var exc = arr[1];
        var url_exc = encodeURIComponent(exc);
        var newUrlPdf = url_exc + '/' + this.meetingObject._id + '/' + fileID + '/' + btoa(response.data.OriginalFileName)
        this.AttachMent = location.protocol + "//" + location.host + "/#/pdfviewer/https:" + newUrlPdf;
        this.showAgenda = false;
        this.hideAgenda = true;
        $("#agendaPdfUploadDialogPSPFD").modal('hide');
        $('body').css('overflow', 'hidden');
        $('.modal').css('overflow', 'auto');
      })
    } else {
      this.meetingMasterService.getAttendanceFile(fileID);
    }
  }

  showAgendaDetail(id, agenda = null) {
    id = parseInt(id)
    this.meetingMasterService.Pagination.next(id);
    const setDisplay = (elId: string, visible: boolean) => {
      const el = document.getElementById(elId);
      if (el) el.style.display = visible ? 'block' : 'none';
    };
    setDisplay('agendaDetails', true);
    setDisplay('Document', false);
    setDisplay('Agenda', false);
    setDisplay('Attendance', false);
    setDisplay('individual-meeting', false);
    setDisplay('agendaAnalytics', false);
  }

  async clickFunc(fileId, page = null) {
    const resolvedFileId = fileId || null;
    if (!resolvedFileId) {
      return;
    }
    const FinalUrlObj: any = await this.getFileUrlPlain(resolvedFileId);
    const FinalUrl =  FinalUrlObj.url
    this.clickedAgenda = FinalUrl;
    if (FinalUrl) {
      const agendaPage = page != null ? parseInt(String(page), 10) : 1;
      this.emitFileURL.emit({FinalUrl, page: agendaPage, filename : FinalUrlObj.filename})
    }
  }

  resolveAgendaDocumentId(agenda: any): string {
    if (!agenda) {
      return '';
    }
    if (
      agenda.AgendaConvertedDocxToPdf &&
      agenda.AgendaConvertedDocxToPdf.DocumentManagementID
    ) {
      return agenda.AgendaConvertedDocxToPdf.DocumentManagementID;
    }
    const generationPdf = agenda.AgendaGenerationPdf;
    if (Array.isArray(generationPdf) && generationPdf.length) {
      const withId = generationPdf.find((item) => item && item.DocumentManagementID);
      return withId ? withId.DocumentManagementID : '';
    }
    if (generationPdf && generationPdf.DocumentManagementID) {
      return generationPdf.DocumentManagementID;
    }
    return '';
  }

  openAgendaItem(agenda: any) {
    const fileId = this.resolveAgendaDocumentId(agenda);
    if (!fileId) {
      return;
    }
    this.clickFunc(fileId, agenda.AgendaNumber);
    this.showAgendaDetail(agenda.AgendaNumber);
  }

  getFileUrlPlain = async (fileID) => {
    console.log("sklog> getFileUrlPlain hit")

    const response = await this.meetingMasterService.getAttendanceFileName(fileID)
    var url = environment.PSSFileurl + "/Document_Type/" + response.data.Filename + "#toolbar=0";
    
    var filename ;
    try{
      console.log("sklog> getFileUrlPlain filename array:",response.data.Filename.split("-"))
      filename  = response.data.Filename.split("-")[1] ;
      //console.error("sklog> getFileUrlPlain filename:",filename)
      if(!filename){
        filename = "File";
      }
    }catch(ex){
      //console.error("Unable to split and fetch filename error:",ex);
      filename  = "File"
    }
    
    return {url:url,filename:filename};
  }

  getFileUrl = async (fileID) => {
    console.log("sklog> getFileUrl hit")

    const response = await this.meetingMasterService.getAttendanceFileName(fileID)
    var url = environment.PSSFileurl + "/Document_Type/" + response.data.Filename + "#toolbar=0";
    var arr = url.split('https:'); // split string        
    var exc = arr[1];
    var url_exc = encodeURIComponent(exc);
    console.log("sklog> getFileUrl url:",url)
    var newUrlPdf = url_exc + '/' + this.meetingObject._id + '/' + fileID + '/' + btoa(response.data.OriginalFileName)
    this.FinalUrl = location.protocol + "//" + location.host + "/#/pdfviewer/https:" + newUrlPdf;
    this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.FinalUrl);
    this.groupList.push({ 'name': this.FinalUrl });
    return this.FinalUrl;
  }

  // Agenda Voting Methods

  /**
   * Load voting data for all agendas in the meeting
   */
  loadAllAgendaVotes() {
    if (!this.agendaObject || this.agendaObject.length === 0) {
      return;
    }

    this.agendaObject.forEach(agenda => {
      if (agenda._id && agenda.isPublished) {
        this.loadAgendaVote(agenda._id);
      }
    });
  }

  /**
   * Load vote summary for a specific agenda
   */
  loadAgendaVote(agendaID: string) {
    this.votingLoading[agendaID] = true;
    this.votingError[agendaID] = null;

    this.meetingMasterService.getAgendaVoteSummary(this.meetingObject._id, agendaID)
      .then((response: any) => {
        if (response != null && response.status == 0) {
          this.agendaVotes[agendaID] = response.data;
        } else {
          this.votingError[agendaID] = response.message || 'Failed to load votes';
        }
        this.votingLoading[agendaID] = false;
      })
      .catch(error => {
        console.error('Error loading agenda vote:', error);
        this.votingError[agendaID] = 'Error loading votes';
        this.votingLoading[agendaID] = false;
      });
  }

  /**
   * Submit a vote for an agenda
   */
  submitVote(agenda: any, voteType: 'APPROVE' | 'REJECT') {
    const user = JSON.parse(localStorage.getItem('user'));
    
    const voteData = {
      MeetingID: this.meetingObject._id,
      AgendaID: agenda._id,
      AgendaNumber: agenda.AgendaNumber,
      AgendaTitle: agenda.AgendaTitle,
      VoteType: voteType,
      UserID: user._id,
      UserName: user.FirstName + ' ' + user.LastName,
      UserEmail: user.EmailId || '',
      CompanyID: user.companyId || JSON.parse(localStorage.getItem('companyDetails'))?.companyId
    };

    this.votingLoading[agenda._id] = true;
    this.votingError[agenda._id] = null;

    this.meetingMasterService.submitAgendaVote(voteData)
      .then((response: any) => {
        if (response != null && response.status == 0) {
          // Reload vote summary to get updated counts
          this.loadAgendaVote(agenda._id);
        } else {
          this.votingError[agenda._id] = response.message || 'Failed to submit vote';
          this.votingLoading[agenda._id] = false;
        }
      })
      .catch(error => {
        console.error('Error submitting vote:', error);
        this.votingError[agenda._id] = error.message || 'Error submitting vote';
        this.votingLoading[agenda._id] = false;
      });
  }

  /**
   * Retract/delete user's vote
   */
  retractVote(agendaID: string) {
    if (!confirm('Are you sure you want to retract your vote?')) {
      return;
    }

    this.votingLoading[agendaID] = true;
    this.votingError[agendaID] = null;

    this.meetingMasterService.retractAgendaVote(this.meetingObject._id, agendaID)
      .then((response: any) => {
        if (response != null && response.status == 0) {
          // Reload vote summary to get updated counts
          this.loadAgendaVote(agendaID);
        } else {
          this.votingError[agendaID] = response.message || 'Failed to retract vote';
          this.votingLoading[agendaID] = false;
        }
      })
      .catch(error => {
        console.error('Error retracting vote:', error);
        this.votingError[agendaID] = error.message || 'Error retracting vote';
        this.votingLoading[agendaID] = false;
      });
  }

  /**
   * Get current user's vote for an agenda
   */
  getUserVote(agendaID: string) {
    return this.agendaVotes[agendaID]?.userVote || null;
  }

  /**
   * Check if user has voted on an agenda
   */
  hasUserVoted(agendaID: string): boolean {
    return !!this.agendaVotes[agendaID]?.userVote;
  }

  /**
   * Get vote counts for an agenda
   */
  getVoteCounts(agendaID: string) {
    const votes = this.agendaVotes[agendaID];
    return {
      approveCount: votes?.approveCount || 0,
      rejectCount: votes?.rejectCount || 0,
      totalVotes: votes?.totalVotes || 0
    };
  }
}
